import mrpStyles from './../mrp.json'

export default {
  color: mrpStyles.colors.SecondaryGreySteel
}
